module.exports = __webpack_public_path__ + "img/2_1-parcheggio-1-bici.23939cfe.png";